module.exports = __webpack_public_path__ + "img/cooler-standard.9c64a67f.png";